<template>
  <el-dialog
      title="开发票"
      append-to-body
      :visible.sync="visible"
      width="700px"
      :before-close="handleClose">

    <div style="position: relative">
      <img src="@/assets/invoice.png" style="width: 100%" alt />
      <div style="position: absolute;top: 177px;left: 18px;font-size: 11px">
<!--        项目名称-->
        {{ product.productName }}
      </div>
      <div style="position: absolute;top: 177px;left: 305px;font-size: 11px">
<!--       数量 -->
        {{ product.quantity }}
      </div>
      <div style="position: absolute;top: 177px;left: 378px;font-size: 11px">
        <!--       单价 -->
        {{ product.productPrice }}
      </div>
      <div style="position: absolute;top: 177px;left: 460px;font-size: 11px">
        <!--       金额 -->
        {{ product.productPrice * product.quantity }}
      </div>
      <div style="position: absolute;top: 307px;left: 500px;font-size: 11px">
        <!--       金额 -->
        {{ product.productPrice * product.quantity }}
      </div>
      <div style="position: absolute;top: 105px;left: 65px;font-size: 11px">
<!--        名称-->
        {{ headerList.headerTitle }}
      </div>
      <div style="position: absolute;top: 137px;left: 172px;font-size: 11px;letter-spacing: 1.5px;">
<!--        信用代码-->
        {{ headerList.taxpayerNumber }}
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 认</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: "invoiceAdd",
  props:{
    visible: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => {}
    },
    headerList: {
      type: Object,
      default: () => {}
    },
  },
  methods:{
    handleInvoicing(headerId){
      this.$http.post(this.$api.invoice.applyInvoice , {headerId:headerId ? headerId : this.headerList.headerId,tradeNo:this.product.tradeNo}).then(res => {
        if (res.data.code == 200) {
          this.$message.success('开票中！请稍后')
          this.$emit('refresh')
          this.loading = false
        }else {
          this.$message.error(res.data.msg)
          this.loading = false
        }
      })
    },
    handleSubmit(){
      this.loading = true
      if (this.headerList.headerId){
        this.$http.post(this.$api.invoice.updateInvoiceHeader , this.headerList).then(res => {
          if (res.data.code == 200) {
            this.handleInvoicing()
          }
        })
      }else {
        this.$http.post(this.$api.invoice.insertInvoiceHeader , this.headerList).then(res => {
          if (res.data.code == 200) {
            this.$http.get(this.$api.invoice.getInvoiceHeader).then(resa => {
              if (resa.data.code == 200) {
                if(resa.data.total >= 1){
                  this.handleInvoicing(res.data.rows[0].headerId)
                }
              }
            })
          }
        })
      }
    },

    handleClose() {
      this.$confirm('确认关闭？')
          .then(()=> {
            this.updateDialog(false)
          })
          .catch(() => {});
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">

</style>
